<!--
作成者：本間
作成日：2020.10.01
画面名：棒グラフ(縦)
機能：棒グラフ(縦)
親子関係：
更新者：
①
更新内容：
①
-->
<script>
  import { Bar, mixins } from 'vue-chartjs';
  export default {
    extends: Bar,
    mixins: [mixins.reactiveData],
    props: ['data', 'options'],
    mounted() {
      this.chartData = this.data;
    },
    watch: {
      data: function() {
        this.chartData = this.data;
      },
    },
  };
</script>
